import { render, staticRenderFns } from "./info-detail.vue?vue&type=template&id=5cb2958a&scoped=true"
import script from "./info-detail.vue?vue&type=script&lang=js"
export * from "./info-detail.vue?vue&type=script&lang=js"
import style0 from "./info-detail.vue?vue&type=style&index=0&id=5cb2958a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb2958a",
  null
  
)

export default component.exports